module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.svg?79be4e9fcffc796ec3b2cb9a1f46d39e";